import { cx } from "@/utils";

export default function Grid({ children, className, ...props }) {
  return (
    <div {...props} className={cx("grid w-full", className)}>
      {children}
    </div>
  );
}
